import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { runtimeConfig, type CeiRuntimeConfig } from '@cei-ufg/ngx-cei-sso-client';

export const ACCESS_TOKEN_KEYS = ['access_token', 'access', 'token', 'accessToken'] as const;

export function resolveDomainApiBasePath(config: CeiRuntimeConfig | undefined = runtimeConfig): string {
  return config?.apiUrl || environment.apiUrl;
}

export function resolveAuthzApiBasePath(config: CeiRuntimeConfig | undefined = runtimeConfig): string {
  return (
    config?.urlBaseApiAutorizacao ||
    environment.urlBaseApiAutorizacao ||
    resolveDomainApiBasePath(config)
  );
}

export function resolveRefreshIntervalMs(config: CeiRuntimeConfig | undefined = runtimeConfig): number {
  return (
    config?.refreshToken?.intervaloSolicitacoes ??
    environment.refreshToken.intervaloSolicitacoes ??
    1_500_000
  );
}

export function buildBearerAuthRequestOptions(
  accessToken: string | undefined,
): {
  headers?: HttpHeaders;
  withCredentials: boolean;
} {
  const options: { headers?: HttpHeaders; withCredentials: boolean } = {
    withCredentials: !accessToken,
  };

  if (accessToken) {
    options.headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
    });
  }

  return options;
}
